export default __webpack_public_path__ + "4b32fe4196e05452155185c8edd10500.svg";